import React from "react";
import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import PhoneButton from "../Buttons/PhoneButton"
import WhatsappButton from "../Buttons/WhatsappButton";
import BackButton from "../Buttons/BackButton"
import TimeTable from "./TimeTable"
import Chip from '@material-ui/core/Chip';
import Toolbar from "../Menu/Toolbar";
import SideDrawer from "../Menu/SideDrawer";
import BackDrop from "../Menu/BackDrop";

const style = {
    "fontFamily":"Open Sans Hebrew", 
    textAlign: "right",
    alignSelf: "stretch",
    lineHeight: 0.2
};

export const buttons_style = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
};

export const sticky = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    background: 'rgb(255, 255, 255) transparent',
    position: '-webkit-sticky',
    position: 'sticky',
    top: 5,
    bottom: 5, 
};

const chips_style = {
    display: 'flex',
    flexWrap: 'wrap',
    lineHeight: 1.7
}

export const paper_style = {
    display: "flex",
    padding: 20,
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
}; 


const top_elements_style = {
    width: "100%"
}

const publish_style = {
    fontFamily:"Open Sans Hebrew", 
    fontSize: "14px",
    color: "#c4c4c4",
    "margin-top": "11px",
    float: "left"
};

const back_button_style = {
    color: "#c4c4c4",
    float: "right"
};

const header_text_style = {
    lineHeight: 1.3
};

class ParentInfo extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            allData: {},
            menuOpen: false,
        };
    }

    menuClickHandler = () => {
        this.setState((prevState) => {
        return { menuOpen: !prevState.menuOpen };
        });
    };

    backDropClickHandler = () => {
        this.setState({ menuOpen: false });
    };

    getPublishDate = () => {
        if (this.props.location.state.details["registration_date"] == undefined) {
            return "1.1.2020";
        }
        return this.props.location.state.details["registration_date"];
    }

    getChildGender() {
        if (this.props.location.state.details["child_gender"] == "female") {
            return "נקבה";
        } 
        return "זכר";
    }

    getDetails() {
        var details = [];
        if (this.props.location.state.details["is_autistic_spectrum"] == true) {
            details.push("מאובחן על הספקטרום האוטיסטי");
        }
        if (this.props.location.state.details["is_intellectual_limitation"] == true) {
            details.push("מאובחן עם מוגבלות שכלית");
        }
        if (this.props.location.state.details["is_delayed_developed"] == true) {
            details.push("מאובחן עם עיכוב התפתחותי");
        }
        if (this.props.location.state.details["is_physical_limitation"] == true) {
            details.push("מאובחן עם מוגבלות פיזית");
        }
        if (this.props.location.state.details["is_behavioral_difficulty"] == true) {
            details.push("מתמודד עם קשיים התנהגותיים");
        }
        if (this.props.location.state.details["is_nursing_assistance"] == true) {
            details.push("נדרש סיוע סיעודי");
        }
        if (this.props.location.state.details["is_medical_assistance"] == true) {
            details.push("נדרש סיוע רפואי");
        }
        return details;    
    }

    getFunctioningLevel() {
        switch(this.props.location.state.details["child_functional_level"]) {
            case "high":
              return "רמת תפקוד גבוהה";
            case "medium":
              return "רמת תפקוד בינונית";
            case "low":
              return "רמת תפקוד נמוכה";
            default:
              return "";
          }
    }

    getFare() {
        return this.props.location.state.details["temp_position"]["salary"];
    }

    getTempNumOfChildren() {
        return this.props.location.state.details["temp_position"]["num_of_children"];
    }

    getTempPositionStartDate() {
        let date = this.props.location.state.details["temp_position"]["start_date"];
        date = date.split(' ');
        let d = date[0];
        let h = date[1];
        let split_d = d.split('/');
        d = split_d[2] + '/' + split_d[1] + '/' + split_d[0];
        let split_h = h.split(':');
        h = split_h[0] + ':' + split_h[1];
        return h + ' ' + d;
    }

    getTempPositionEndDate() {
        let date = this.props.location.state.details["temp_position"]["end_date"];
        date = date.split(' ');
        let d = date[0];
        let h = date[1];
        let split_d = d.split('/');
        d = split_d[2] + '/' + split_d[1] + '/' + split_d[0];
        let split_h = h.split(':');
        h = split_h[0] + ':' + split_h[1];
        return h + ' ' + d;
    }

    isRegJob() {
        // if the parent needs a regular job at any day, return true.
        if ((this.props.location.state.details["work_on_sunday"]["start_time"] != "") ||
        (this.props.location.state.details["work_on_monday"]["start_time"] != "") ||
        (this.props.location.state.details["work_on_tuesday"]["start_time"] != "") ||
        (this.props.location.state.details["work_on_wednesday"]["start_time"] != "") ||
        (this.props.location.state.details["work_on_thursday"]["start_time"] != "") ||
        (this.props.location.state.details["work_on_friday"]["start_time"] != "") ||
        (this.props.location.state.details["work_on_saturday"]["start_time"] != "")) {
            return true;
        }
        return false;
    }
    
    isTempJob() {
        // if the parent's temp_job field is defined, return true.
        if (this.props.location.state.details["temp_position"]["start_date"] != "") {
          return true;
        }
        return false;
    }

    render() {
        // if the page was refreshed, redirect to home.
        if (this.props.location.state == undefined) {
            window.location.assign('/');
        }
        // menu related.
        let sideDrawer;
        let backDrop;
        if (this.state.menuOpen) {
            sideDrawer = <SideDrawer userData={this.props.location.state.details} closeMenu={this.backDropClickHandler} />;
            backDrop = <BackDrop click={this.backDropClickHandler} />;
        }
        // create a chip array to display details about disabillity.
        var details = this.getDetails();
        let details_display = [];
        // if there are no additional details, display "other".
        if (details.length == 0) {
            details_display = <p><font size="2" style={{fontFamily:"Open Sans Hebrew"}}> אחר </font></p>;
        // if there are details, put them in chips.
        } else {
            function addChip(item) {
                details_display.push(<Chip size="small" fontFamily="Open Sans Hebrew" label={item}/>);
                details_display.push(<a>&nbsp;</a>);
            }
            details.forEach(addChip);
            details_display = <div style={chips_style}>{details_display}</div>;
        }
        // display reg job only if exists.
        let regJob;
        if (this.isRegJob()) {
            regJob = (     
                <div>
                    <Box m={5}/>
                    <p><b><font size="4" color="#a8a8a8" style={header_text_style}> פרטי משרה קבועה </font></b></p>
                    <TimeTable attributes={this.props.location.state.details} />
                </div>                   
            )
        }
        // display temp job only if exists.
        let tempJob;
        if (this.isTempJob()) {
            tempJob = (     
                <div>
                    <Box m={5}/>
                    <p><b><font size="4" color="#a8a8a8" style={header_text_style}> פרטי בייביסיטר חד פעמי </font></b></p>
                    <p><b><font size="3" style={header_text_style}> מועד התחלה </font></b></p>
                    <p><font size="3">{this.getTempPositionStartDate()} </font></p>
                    <p><b><font size="3" style={header_text_style}> מועד סיום </font></b></p>
                    <p><font size="3">{this.getTempPositionEndDate()} </font></p>
                    <p><b><font size="3" style={header_text_style}> תעריף לשעה </font></b></p>
                    <p><font size="3">{this.getFare()} ₪ </font></p>
                    <p><b><font size="3" style={header_text_style}> מספר הילדים בבית במועד הבייביסיטר </font></b></p>
                    <p><font size="3">{this.getTempNumOfChildren()} </font></p>

                </div>                   
            )
        }     
        return (
            <Container component="main" maxWidth="xs">
                <Toolbar drawerClickHandler={this.menuClickHandler} textPage={this.props.location.state.details["full_name"]}/>
                {sideDrawer}
                {backDrop}
                <Box m={5}/>
                <Paper style = {paper_style}>
                    <div style = {style}>
                        <div style = {top_elements_style}>
                            <div style={back_button_style}>
                                <BackButton></BackButton>
                            </div>
                            <div style={publish_style}>
                                <text> פורסם: {this.getPublishDate()}</text>
                            </div>
                        </div>
                        <Box m={7}/>
                        <p><b><font size="4"> {this.props.location.state.details["full_name"]} </font></b></p>
                        <p><font size="4"> {this.props.location.state.details["city"]}</font></p>
                        <Box m={5}/>
                        <div>
                            <p><b><font size="3"> מייל </font></b></p>
                            <p><font size="3"> {this.props.location.state.details["email"]} </font></p>
                        </div>
                        <Box m={5}/>
                        <div>
                            <p><b><font size="3"> טלפון </font></b></p>
                            <p><font size="3"> {this.props.location.state.details["phone_number"]} </font></p>
                        </div>                        
                        <Box m={5}/>
                        <p><b><font size="4" color="#a8a8a8" style={header_text_style}> פרטי הילד/ה </font></b></p>
                        <Box m={3}/>
                        <div>
                            <p><b><font size="3"> מגדר הילד/ה </font></b></p>
                            <p><font size="3"> {this.getChildGender()} </font></p>
                        </div>
                        <Box m={5}/>
                        <div>
                            <p><b><font size="3" style={header_text_style}> פרטים על המוגבלות </font></b></p>
                            <div> {details_display} </div>
                        </div>
                        <Box m={5}/>
                        <div>
                            <p><b><font size="3"> רמת התפקוד </font></b></p>
                            <p><font size="3"> {this.getFunctioningLevel()} </font></p>
                        </div>
                        <Box m={5}/>
                        
                        {regJob}
                        {tempJob}
                        <Box m={5}/>
                        <div style={sticky} >
                            <WhatsappButton attributes = {this.props.location.state.details["phone_number"]} city={this.props.location.state.details["city"]} />
                            <Box m={1}/>
                            <PhoneButton attributes = {this.props.location.state.details["phone_number"]} />
                        </div>
                    </div> 
                </Paper>
            </Container>  
        );
    }
}

export default ParentInfo;